/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import DialogModal from "../DialogModal/DialogModal";

type SeparationDivorceModalProps = {
  open: boolean;
  onClose: () => void;
};

const SeparationDivorceModal = ({ open, onClose, ...rest }: SeparationDivorceModalProps) => {
  return (
    <DialogModal open={open} onClose={onClose} {...rest} title={"Trennungszeitraum"}>
      <p>
        Eine Scheidung ist möglich, wenn das Trennungsjahr abgelaufen ist. Das Trennungsjahr kann dabei bei Auszug des einen Ehepartners aus der gemeinsamen
        Wohnung beginnen oder bei einer Trennung von Tisch und Bett innerhalb der gemeinsamen Wohnung. Dies bedeutet, dass Sie getrennte Schlafzimmer haben.
        Falls es über einen kürzeren Zeitraum zu einem Versöhnungsversuch kommt, werden dadurch die Trennungsfristen nicht unterbrochen.
      </p>
      <p>Die Trennungszeit muss gegenüber dem Gericht grundsätzlich nicht nachgewiesen werden, wenn beide Eheleute den Trennungszeitpunkt bestätigen.</p>
      <p>Der Scheidungsantrag kann bereits einige Wochen vor Ablauf des Trennungsjahres bei Gericht eingereicht werden.</p>
    </DialogModal>
  );
};

export default SeparationDivorceModal;
